<template lang="pug">
  div.lmm-content-body-padded
    b-container(fluid)
      b-row
        b-col.page-wrap(cols="12")
          div(slot="header").d-flex.justify-content-between.page-header
            div
              span.page-title {{$t('top10')}} {{$t('statistics')}}
            b-row
              b-col.mr-3
                datepicker(
                  :value="range.start",
                  :bootstrap-styling="true",
                  :language="range.lang",
                  format="yyyy-MM-dd",
                  @selected="startDateChanged")
              b-col.mr-3
                datepicker(
                  :value="range.end",
                  :bootstrap-styling="true",
                  :language="range.lang",
                  :disabledDates="range.disabledDates",
                  format="yyyy-MM-dd",
                  @selected="endDateChanged")
              div
                b-button(size="sm", @click="getData" variant="secondary" ) {{$t('search')}}
          // 테이블
          b-row.mb-2
            b-col(cols="12")
              b-card(no-body)
                div(slot="header") {{$t('by_user', {v: $t('remote.remote.title')})}}
                  //b-badge.float-right(variant="info") {{remoteUser.total}}
                div
                  b-table.rate-table(
                    :busy.sync="remoteUser.busy",
                    :fields="remoteUser.fields",
                    :items="remoteUser.items",
                    :empty-text="$t('no-content')",
                    show-empty)
                    template(#table-colgroup)
                      col(style="width:15%")
                      col(style="width:15%")
                      col
                    template(slot="HEAD_reg_mail", slot-scope="data")
                      | {{$t('user')}}
                    template(slot="HEAD_graph", slot-scope="data")
                      | {{$t('use_rate')}}
                    template(slot="HEAD_count", slot-scope="data")
                      | {{$t('use_count')}}
                    template(v-slot:cell(alias)="row", style="color: #0073BB")
                    template(v-slot:cell(graph)="row")
                      //b-progress(
                      //  v-if="row.item.usage !== -1"
                      //  :value="row.item.usage",
                      //  :animated="true",
                      //  variant="info",
                      //  striped)
                      div.usage {{Math.round(row.item.usage)}}%
            b-col.mt-3(cols="12")
              b-card(no-body)
                div(slot="header") {{$t('by_device', {v: $t('remote.remote.title')})}}
                  //b-badge.float-right(variant="info") {{remoteDevice.total}}
                div
                  b-table.rate-table(
                    :busy.sync="remoteDevice.busy",
                    :fields="remoteDevice.fields",
                    :items="remoteDevice.items",
                    :empty-text="$t('no-content')",
                    show-empty)
                    template(#table-colgroup)
                      col(style="width:15%")
                      col(style="width:15%")
                      col
                    template(slot="HEAD_alias", slot-scope="data")
                      | {{$t('columns.alias')}}
                    template(slot="HEAD_graph", slot-scope="data")
                      | {{$t('use_rate')}}
                    template(slot="HEAD_count", slot-scope="data")
                      | {{$t('use_count')}}
                    template(v-slot:cell(graph)="row")
                      div {{Math.round(row.item.usage)}}%
          //b-row.mb-2
          //  b-col(cols="6")
          //    b-card(no-body)
          //      div(slot="header") {{$t('by_type', {v: $t('alert_count')})}}
          //        b-badge.float-right(variant="info") {{alertType.total}}
          //      div
          //        b-table(
          //          :busy.sync="alertType.busy",
          //          :fields="alertType.fields",
          //          :items="alertType.items",
          //          :empty-text="$t('no-content')",
          //          show-empty)
          //          template(slot="HEAD_category", slot-scope="data")
          //            | {{$t('alert')}}
          //          template(slot="HEAD_graph", slot-scope="data")
          //            | {{$t('use_rate')}}
          //          template(slot="HEAD_count", slot-scope="data")
          //            | {{$t('use_count')}}
          //          template(v-slot:cell(graph)="row")
          //            b-progress(
          //              v-if="row.item.usage !== -1"
          //              :value="row.item.usage",
          //              :animated="true",
          //              variant="info",
          //              striped)
          //  b-col(cols="6")
          //    b-card(no-body)
          //      div(slot="header") {{$t('by_device', {v: $t('alert_count')})}}
          //        b-badge.float-right(variant="info") {{alertDevice.total}}
          //      div
          //        b-table(
          //          :busy.sync="alertDevice.busy",
          //          :fields="alertDevice.fields",
          //          :items="alertDevice.items",
          //          :empty-text="$t('no-content')",
          //          show-empty)
          //          template(slot="HEAD_device", slot-scope="data")
          //            | {{$t('columns.alias')}}
          //          template(slot="HEAD_graph", slot-scope="data")
          //            | {{$t('use_rate')}}
          //          template(slot="HEAD_count", slot-scope="data")
          //            | {{$t('use_count')}}
          //          template(v-slot:cell(graph)="row")
          //            b-progress(
          //              v-if="row.item.usage !== -1"
          //              :value="row.item.usage",
          //              :animated="true",
          //              variant="info",
          //              striped)
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'
import store from '@/api/store'
import {getCurrentLanguage} from '@/i18n'
import * as datePickerLocale from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'
import {AnalysticAPI} from '../../api'
import {user} from '../../api/access'
export default {
  name: 'rate-summary-component',
  components: { Datepicker },
  mounted () {
    const stored = store.get(`analystic-dash-${user().pk}`)
    if (stored) {
      this.remoteUser.items = stored.remoteUser.filter(item => item.usage !== -1)
      this.remoteDevice.items = stored.remoteDevice.filter(item => item.usage !== -1)
      this.alertType.items = stored.alertType
      this.alertDevice.items = stored.alertDevice
    }
    this.getData()
  },
  methods: {
    startDateChanged (date) {
      this.range.start = date
      this.range.disabledDates.to = date
    },
    endDateChanged (date) {
      this.range.end = date
    },
    getData () {
      this.remoteUser.busy = true
      this.remoteDevice.busy = true
      this.alertType.busy = true
      this.alertDevice.busy = true

      const rootParams = {
        limit: 10,
        offset: 0,
        order: 'desc',
        search_mode: 'pagination',
        start_date: moment(this.range.start).format('YYYY-MM-DD'),
        end_date: moment(this.range.end).format('YYYY-MM-DD')
      }

      const remoteByUserParams = _.assign({}, rootParams, {by: 'mgrid', type: 'user'})
      const remoteByDeviceParams = _.assign({}, rootParams, {by: 'mgrid', type: 'device'})
      const alertByUserParams = _.assign({}, rootParams, {by: 'create_time', type: 'user'})
      const alertByDeviceParams = _.assign({}, rootParams, {by: 'create_time', type: 'device'})
      const xhr = axios.all([
        AnalysticAPI.dash.get('remote', {params: remoteByUserParams}),
        AnalysticAPI.dash.get('remote', {params: remoteByDeviceParams}),
        AnalysticAPI.dash.get('alert', {params: alertByUserParams}),
        AnalysticAPI.dash.get('alert', {params: alertByDeviceParams})
      ])
      
      this.remoteUser.total = 0
      this.remoteDevice.total = 0
      this.alertType.total = 0
      this.alertDevice.total = 0

      xhr
        .then(
          axios.spread((remoteUser, remoteDevice, alertType, alertDevice) => {
            this.remoteUser.items = remoteUser.data.objects.filter(item => item.usage !== -1)
              .sort((a, b) => b.count - a.count)
              .map(v => {
                if (v.count === -1) {
                  v.reg_mail = '-'
                  v.count = null
                } else this.remoteUser.total += v.count
                return v
              })

            this.remoteDevice.items = remoteDevice.data.objects.filter(item => item.usage !== -1)
              .sort((a, b) => b.count - a.count)
              .map(v => {
                if (v.count === -1) {
                  v.alias = '-'
                  v.count = null
                } else this.remoteDevice.total += v.count
                return v
              })

            this.alertType.items = alertType.data.objects
              .sort((a, b) => b.count - a.count)
              .map(v => {
                if (v.count === -1) {
                  v.category = '-'
                  v.count = null
                } else this.alertType.total += v.count
                return v
              })

            this.alertDevice.items = alertDevice.data.objects
              .sort((a, b) => b.count - a.count)
              .map(v => {
                if (v.count === -1) {
                  v.device = '-'
                  v.count = null
                } else this.alertDevice.total += v.count
                return v
              })

            this.remoteUser.busy = false
            this.remoteDevice.busy = false
            this.alertType.busy = false
            this.alertDevice.busy = false

            store.set(`analystic-dash-${user().pk}`, {
              remoteUser: this.remoteUser.items,
              remoteDevice: this.remoteDevice.items,
              alertType: this.alertType.items,
              alertDevice: this.alertDevice.items
            })
          })
        )
    }
  },
  data () {
    let disabledDateInit = new Date()
    disabledDateInit.setDate(-1)
    return {
      range: {
        start: (new Date().setDate(-1)),
        end: new Date(),
        disabledDates: { to: disabledDateInit },
        lang: datePickerLocale[getCurrentLanguage()]
      },
      remoteUser: {
        busy: true,
        total: 0,
        fields: [
          { key: 'reg_mail', label: this.$t('user') },
          { key: 'graph', label: this.$t('use_rate') },
          { key: 'count', label: this.$t('use_count') }
        ],
        items: [],
      },
      remoteDevice: {
        busy: true,
        total: 0,
        fields: [
          { key: 'alias', label: this.$t('device') },
          { key: 'graph', label: this.$t('use_rate') },
          { key: 'count', label: this.$t('use_count') }
        ],
        items: [],
      },
      alertType: {
        busy: true,
        total: 0,
        fields: [
          { key: 'category', label: this.$t('alert') },
          { key: 'graph', label: this.$t('use_rate') },
          { key: 'count', label: this.$t('use_count') }
        ],
        items: [
          { category: '', usage: -1 },
          { category: '', usage: -1 },
          { category: '', usage: -1 },
          { category: '', usage: -1 },
          { category: '', usage: -1 },
          { category: '', usage: -1 },
          { category: '', usage: -1 },
          { category: '', usage: -1 },
          { category: '', usage: -1 },
          { category: '', usage: -1 }
        ]
      },
      alertDevice: {
        busy: true,
        total: 0,
        fields: [
          { key: 'device', label: this.$t('device') },
          { key: 'graph', label: this.$t('use_rate') },
          { key: 'count', label: this.$t('use_count') }
        ],
        items: [
          { device: '', usage: -1 },
          { device: '', usage: -1 },
          { device: '', usage: -1 },
          { device: '', usage: -1 },
          { device: '', usage: -1 },
          { device: '', usage: -1 },
          { device: '', usage: -1 },
          { device: '', usage: -1 },
          { device: '', usage: -1 },
          { device: '', usage: -1 }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.lmm-content-body-padded {
  padding: 0;
  margin: 0;
}

.row, .col, .container-fluid, .container, .col-12 {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

.page-header {
  padding: 0 0 0 1.5rem;
  margin-bottom: 0.8rem;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
  > .card-header {
    border-bottom: 1px solid #D2D2D2;
    font-size: 0.9rem;
    font-weight: 500;
  }
}

::v-deep .b-table {
  margin: 0;
  tr, td, th {
    padding: 0.5rem 0 0.5rem 1rem;
    position: relative;
    font-weight: 400;
  }
  th:nth-child(1), th:nth-child(2) {
    position: relative;
    padding-right: 0;
  }
  td {
    color: #6F6F6F;
  }
}

::v-deep .form-control {
  border: 1px solid #6F6F6F;
  height: 1.7rem;
  &:disabled,
  &[readonly] {
    background-color: #FFFFFF;
  }
}

.btn-secondary {
  color: black !important;
  font-weight: 400;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

</style>
